const productData = [
  {
    id: 'ai-voice-engine',
    title: 'AI Voice Engine',
    type: 'Voice automation system',
    summary: 'A Bularis Tech engineering project combining AI conversation, speech recognition and synthesis, and telephony workflows as a foundation for tailored business voice automation.',
    path: '/portfolio/ai-voice-engine',
  },
  {
    id: 'shopify-payment-customization',
    title: 'Shopify Payment Customization',
    type: 'Shopify app',
    summary: 'Customize which payment methods customers see at checkout, how those methods are named, and the order in which they appear.',
    path: '/products/shopify-payment-customization',
  },
  {
    id: 'product-widget',
    title: 'Product Widget',
    type: 'Shopify app',
    summary: 'Create configurable card-based widgets and map each card to a Shopify product or specific product variant.',
    path: '/products/product-widget',
  },
];

export default productData;
